<script lang="ts" setup>
import { EditableArea } from "@magnolia/vue-editor";
import { Heading } from "~/components/clarity-ui/Heading";
import BenefitsComponentArea from "~/templates/components/cms/BenefitsComponentArea.vue";
import type { mgnlHeadline } from "~/types/magnolia";

// todo: correct type needs to be defined
export interface BenefitsComponentProps {
  backgroundColor?: string;
  headline?: mgnlHeadline;
  main?: object; // Magnolia object
}

const { backgroundColor } = defineProps<BenefitsComponentProps>();

provide("backgroundColor", backgroundColor);
</script>

<template>
  <div class="space-y-8 xl:space-y-12">
    <Heading v-if="headline?.text" class="text-center" :tag="headline?.tag ?? 'h2'">
      {{ headline?.text }}
    </Heading>
    <EditableArea :content="main" :custom-view="BenefitsComponentArea" />
  </div>
</template>
